/* eslint-disable no-console */
import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'
import cn from 'classnames'
import { FC, ReactNode, useMemo } from 'react'

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  marginLeft?: string | number
  backgroundColor?: string
  textColor?: string
  fontSize?: string
  boxShadow?: string
  children?: ReactNode
  fromPage?: string
}

const CustomTooltip: FC<CustomTooltipProps> = ({
  children,
  placement = 'top',
  marginLeft = '1rem',
  backgroundColor = '#616161', // '#FFFFFF',
  textColor = '#FFFFFF', //'#011d58',
  fontSize = '11px',
  fromPage = '',
  //boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.5)',
  ...props
}) => {
  const StyledTooltip = useMemo(() => {
    return styled(({ className, ...tooltipProps }: TooltipProps) => (
      <Tooltip {...tooltipProps} classes={{ tooltip: className }} />
    ))(() => ({
      backgroundColor,
      color: textColor,
      fontFamily: 'Poppins, sans-serif',
      fontSize,
      //boxShadow,
      ...(placement === 'top' && { marginBottom: '0.5rem !important' }),
      ...(placement === 'right' && {
        marginLeft: typeof marginLeft === 'number' ? `${marginLeft}rem !important` : `${marginLeft} !important`,
      }),
    }))
  }, [backgroundColor, textColor, fontSize, placement, marginLeft])

  return (
    <StyledTooltip placement={placement} {...props}>
      <div className={cn(fromPage === 'homepage' && 'pt-[3px]')}>{children}</div>
    </StyledTooltip>
  )
}

export default CustomTooltip
